import { defineStore } from 'pinia'
import moment from 'moment'
import { camelCase } from 'lodash'
import repositoryFactory from '@/factories/repository-factory'
import NotificationsRepository from '@/repositories/notifications-repository'
import Notifications from '@/models/Notifications'
import { useInitDataStore } from '@/stores/initDataStore'
import { NotificationInfoItem } from '@/models/initData/NotificationInfo'

const storeKey = 'notifications'
const STORAGE_KEY = `${process.env.VUE_APP_TARGET}.IWS.NOTIFICAITON.AFTER_ID`
const DEFAULT_SPAN = 3 // 日: afterIdが指定されなかった場合にデフォルトで取得する現在からの期間
const DEFAULT_AFTER_ID = moment().subtract(DEFAULT_SPAN, 'days').toISOString()

export const useNotificationsStore = defineStore(storeKey, {
  state: () => ({
    notifications: undefined as Notifications | undefined,
    notificationsForHeader: undefined as Notifications | undefined,
  }),

  getters: {
    hasNotification: state => {
      return state.notifications?.hasItem()
    },
    priorInfo: state => {
      const initDataStore = useInitDataStore()
      const notificationInfo = initDataStore.initData.notificationInfo || {}
      let result = undefined as NotificationInfoItem | undefined

      if (!state.notifications?.hasItem()) {
        return undefined
      }

      state.notifications?.items.forEach(item => {
        const status = camelCase(item.status)
        const infoItem = notificationInfo[status]

        if (infoItem === undefined) {
          return
        }

        const { notificationLevel } = infoItem

        if (result === undefined) {
          result = infoItem

          return
        }

        if (notificationLevel > result.notificationLevel) {
          result = infoItem
        }
      })

      return result
    },
  },

  actions: {
    async fetch(afterId?: string) {
      const repository = (await repositoryFactory.create()).get(storeKey) as NotificationsRepository
      const initDataStore = useInitDataStore()
      const areaList = initDataStore.initData.definitionInfo.alerts?.common?.areaInfo || []
      const areaCodes = areaList.map(a => a.code)
      const stationIds = initDataStore.initData.stationList.map(s => s.stationId)
      const params = {
        afterId: afterId || DEFAULT_AFTER_ID,
        weatherWarning: { areaCodes },
        threshold: { stationIds },
      }

      return repository.fetch(params)
    },

    // localStorageに保存している最終取得IDをリクエストに付与
    async fetchWithAfterId() {
      const afterId = window.localStorage.getItem(STORAGE_KEY) || undefined

      this.notifications = await this.fetch(afterId)

      if (this.notifications.last !== undefined) {
        window.localStorage.setItem(STORAGE_KEY, this.notifications.last.id)
      }

      return this.notifications
    },

    // ヘッダの注意報警報用にすべての通知情報を取得
    async fetchWithoutAfterId() {
      this.notificationsForHeader = await this.fetch()

      return this.notificationsForHeader
    },
  },
})
